import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SectionLabel = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const PanelStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
`

export const HeaderMetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.5rem 0 0;
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.5rem 0 1rem;
`

export const DaysToEmptyRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${tokens.border.hairline};
`

export const DaysToEmptyValue = styled.span`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${tokens.text.primary};
`
